module.exports = __webpack_public_path__ + "right.d9f3a6e5ad1c414e24cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/right.svg
// module id = 1295
// module chunks = 2